var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('login-card',{attrs:{"disable-logout":!_vm.hasAuthUser},on:{"cancel":_vm.redirect,"success":_vm.redirect}}),_c('about-line',{staticClass:"py-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }